import React from "react";

// Ornamental SVG dividers for the engraving feel
export const StarDivider = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <div className="flex-1 h-[2px] bg-asphalt" />
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M11 0L13.5 8.5L22 11L13.5 13.5L11 22L8.5 13.5L0 11L8.5 8.5L11 0Z" fill="currentColor" />
    </svg>
    <div className="flex-1 h-[2px] bg-asphalt" />
  </div>
);

export const RuleDivider = ({ className = "" }) => (
  <div className={`relative ${className}`}>
    <div className="h-[3px] bg-asphalt" />
    <div className="h-[1px] bg-asphalt mt-1.5" />
  </div>
);

export const SectionEyebrow = ({ children, testid }) => (
  <div data-testid={testid} className="font-mono text-xs uppercase tracking-[0.35em] text-ink mb-3">
    ✦ {children}
  </div>
);

export const SectionTitle = ({ children, kind = "display", className = "" }) => {
  const cls =
    kind === "western"
      ? "font-western text-3xl sm:text-4xl md:text-5xl"
      : "font-display text-4xl sm:text-5xl md:text-6xl uppercase tracking-tighter";
  return <h2 className={`${cls} ${className}`}>{children}</h2>;
};
